import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline'
import HourglassEmpty from '@mui/icons-material/HourglassEmpty'
import { Box, Button, Stack, TextField, Tooltip, Typography } from '@mui/material'
import React from 'react'
import type { ExclusionAreaObservation } from '../../../../types/apiModels'
import { findingsTypesConventions } from '../../../../utils/findingColors'
import { ExclusionAreaObservationCommentsAccordion } from './ExclusionAreaObservationCommentsAccordion'

const observationTypeLabels = [
  { label: 'Observación', color: findingsTypesConventions.observed.color },
  { label: 'No Conformidad a Corregir', color: findingsTypesConventions.nonComplaintToFix.color },
  { label: 'No Conformidad Grave', color: findingsTypesConventions.nonComplaintSevere.color },
]

interface ExclusionAreaObservationCardProps {
  observation: ExclusionAreaObservation
  canResolve: boolean
  canComment: boolean
  onResolve: (observationId: string) => void
}

export const ExclusionAreaObservationCard: React.FC<ExclusionAreaObservationCardProps> = ({
  observation,
  canResolve,
  canComment,
  onResolve,
}) => {
  const typeInfo = observationTypeLabels[observation.type] ?? observationTypeLabels[0]

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'column',
        borderRadius: 2,
        padding: 1,
        margin: 0.5,
        backgroundColor: 'lightgray',
      }}
    >
      <Stack alignItems="center" direction="row" pb={0.5}>
        <Typography sx={{ fontWeight: 'bold' }} variant="body1">
          Tipo
        </Typography>
        <Typography variant="body1">{`: ${typeInfo.label}`}</Typography>
        <Box
          sx={{
            backgroundColor: typeInfo.color,
            border: '1px solid black',
            borderRadius: '100%',
            height: '16px',
            mx: 0.5,
            width: '16px',
          }}
        />
      </Stack>

      <Stack direction="column" pb={1} width="100%">
        <Typography sx={{ fontWeight: 'bold', alignSelf: 'flex-start' }} variant="body1">
          Descripción
        </Typography>
        <TextField
          multiline
          inputProps={{ readOnly: true }}
          placeholder="Comentario"
          rows={2}
          value={observation.comment}
        />
      </Stack>

      <ExclusionAreaObservationCommentsAccordion
        canComment={canComment}
        observationId={observation.id}
      />

      <Box mt={0.5} sx={{ alignSelf: 'flex-end' }}>
        {observation.resolved ? (
          <Tooltip title="Resuelta">
            <CheckCircleOutline color="success" sx={{ fontSize: 28 }} />
          </Tooltip>
        ) : canResolve ? (
          <Button color="success" variant="contained" onClick={() => onResolve(observation.id)}>
            <Typography variant="body1">Resolver</Typography>
          </Button>
        ) : (
          <Tooltip title="En espera de resolución">
            <HourglassEmpty color="warning" sx={{ fontSize: 24 }} />
          </Tooltip>
        )}
      </Box>
    </Box>
  )
}
